// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CheckComponent.module.css */

:root {
  --primary-color: #007bff;
  --secondary-color: #fdfdfd;
  --text-color: #333;
}

.CheckComponent_checkPageContainer__0sL1A {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 10px;
  overflow-y: auto;
  background-color: var(--secondary-color);
  font-family: sans-serif;
  padding-bottom: 70px;
}

.CheckComponent_errorText__cEgKI {
  color: red;
  font-weight: bold;
  margin-top: 6px;
  text-align: center;
  font-size: 0.85rem;
}

.CheckComponent_checkDetails__GMWjv {
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.CheckComponent_checkDetails__GMWjv h3 {
  color: #4caf50;
  font-size: 1.2rem;
  margin-bottom: 15px;
  text-align: center;
}

.CheckComponent_detailsList__kg-ke {
  list-style: none;
  padding: 0;
  font-size: 0.9rem;
}

.CheckComponent_detailsList__kg-ke li {
  margin-bottom: 8px;
}

.CheckComponent_detailsList__kg-ke li strong {
  font-weight: bold;
}

.CheckComponent_checkActions1__Xx9L- {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 15px;
}

.CheckComponent_checkActions1__Xx9L- button {
  padding: 8px 16px;
  background-color: var(--primary-color);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.CheckComponent_checkActions1__Xx9L- button:hover {
  background-color: #0056b3;
}

.CheckComponent_checkActions1__Xx9L- button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.CheckComponent_checkForm1__6vtyr {
  background-color: #fdfdfd;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.CheckComponent_checkModalInputGroup__QNyd\\+ {
  margin-bottom: 0.5rem;
}

.CheckComponent_checkModalInputGroup__QNyd\\+ label {
  display: block;
  font-size: 0.85rem;
  margin-bottom: 0.2rem;
  font-weight: bold;
}

.CheckComponent_contactInputWrapper__bI-Oc {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  flex-wrap: wrap;
}

.CheckComponent_contactOptions__BzX9J,
.CheckComponent_paymentOptions__FnHwF {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  margin: 15px 0;
}

.CheckComponent_contactOption__jI6Ln,
.CheckComponent_paymentOption__NsHjX {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 10px);
  box-sizing: border-box;
  height: 40px;
  padding: 10px;
  border: 1px solid #ccc;
  background-color: #f0f0f0;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  word-wrap: break-word;
  white-space: normal;
  transition: background-color 0.2s, border-color 0.2s;
}

.CheckComponent_contactOption__jI6Ln:hover,
.CheckComponent_paymentOption__NsHjX:hover {
  background-color: #e0e0e0;
}

.CheckComponent_selected__WK2UD {
  background-color: rgb(0, 123, 255) !important;
  border-color: rgb(0, 123, 255) !important;
  color: #fff !important;
}

.CheckComponent_checkDetailList__ENVNZ,
.CheckComponent_receiptInfoCheck__3Urcd {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  padding: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.CheckComponent_receiptInfoCheck__3Urcd div {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.CheckComponent_receiptInfoCheck__3Urcd i.CheckComponent_receiptIcon__pbVHO {
  margin-right: 5px;
  font-size: 16px;
  color: #555;
}

.CheckComponent_productsList__7PqaH {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 10px 0;
  list-style: none;
  overflow-x: auto;
}

.CheckComponent_productsList__7PqaH li,
.CheckComponent_productsList__7PqaH i.CheckComponent_receiptIcon__pbVHO {
  font-size: 14px;
  color: #333;
  gap: 10px;
}

.CheckComponent_productsList__7PqaH li {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.CheckComponent_productName__\\+LYZ- {
  white-space: nowrap;
  flex: 1 1 auto;
}

.CheckComponent_productactual_quantity__LfR7b,
.CheckComponent_productPrice__Pz0qI {
  white-space: nowrap;
}

@media (max-width: 600px) {
  .CheckComponent_productsList__7PqaH {
    padding: 8px;
    gap: 8px;
  }
  .CheckComponent_productsList__7PqaH li {
    font-size: 12px;
    gap: 8px;
  }
  .CheckComponent_productsList__7PqaH i.CheckComponent_receiptIcon__pbVHO {
    font-size: 14px;
    margin-right: 4px;
  }
}

.CheckComponent_buttonGroup__2e6M1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
}

.CheckComponent_issueCheckButton__0ePRa,
.CheckComponent_closeReceiptButton__QpMct {
  padding: 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  font-size: 0.95rem;
  font-weight: bold;
}

.CheckComponent_issueCheckButton__0ePRa {
  background-color: rgb(0, 123, 255);
  color: #fff;
  margin-bottom: 10px;
}

.CheckComponent_closeReceiptButton__QpMct {
  background-color: #ffd700;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/modules/Dispatcher/RouteDetails/components/CheckComponent.module.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,QAAQ;EACV;EACA;IACE,eAAe;IACf,QAAQ;EACV;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb","sourcesContent":["/* CheckComponent.module.css */\r\n\r\n:root {\r\n  --primary-color: #007bff;\r\n  --secondary-color: #fdfdfd;\r\n  --text-color: #333;\r\n}\r\n\r\n.checkPageContainer {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  padding: 10px;\r\n  overflow-y: auto;\r\n  background-color: var(--secondary-color);\r\n  font-family: sans-serif;\r\n  padding-bottom: 70px;\r\n}\r\n\r\n.errorText {\r\n  color: red;\r\n  font-weight: bold;\r\n  margin-top: 6px;\r\n  text-align: center;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.checkDetails {\r\n  padding: 10px;\r\n  background-color: #f9f9f9;\r\n  border-radius: 8px;\r\n  box-shadow: 0 0 10px rgba(0,0,0,0.1);\r\n}\r\n\r\n.checkDetails h3 {\r\n  color: #4caf50;\r\n  font-size: 1.2rem;\r\n  margin-bottom: 15px;\r\n  text-align: center;\r\n}\r\n\r\n.detailsList {\r\n  list-style: none;\r\n  padding: 0;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.detailsList li {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.detailsList li strong {\r\n  font-weight: bold;\r\n}\r\n\r\n.checkActions1 {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  margin-top: 15px;\r\n}\r\n\r\n.checkActions1 button {\r\n  padding: 8px 16px;\r\n  background-color: var(--primary-color);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.checkActions1 button:hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n.checkActions1 button:disabled {\r\n  background-color: #ccc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.checkForm1 {\r\n  background-color: #fdfdfd;\r\n  padding: 10px;\r\n  border-radius: 4px;\r\n  box-shadow: 0 0 10px rgba(0,0,0,0.1);\r\n}\r\n\r\n.checkModalInputGroup {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.checkModalInputGroup label {\r\n  display: block;\r\n  font-size: 0.85rem;\r\n  margin-bottom: 0.2rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.contactInputWrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.contactOptions,\r\n.paymentOptions {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  gap: 10px;\r\n  margin: 15px 0;\r\n}\r\n\r\n.contactOption,\r\n.paymentOption {\r\n  flex: 0 0 calc(50% - 10px);\r\n  box-sizing: border-box;\r\n  height: 40px;\r\n  padding: 10px;\r\n  border: 1px solid #ccc;\r\n  background-color: #f0f0f0;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.9rem;\r\n  word-wrap: break-word;\r\n  white-space: normal;\r\n  transition: background-color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.contactOption:hover,\r\n.paymentOption:hover {\r\n  background-color: #e0e0e0;\r\n}\r\n\r\n.selected {\r\n  background-color: rgb(0, 123, 255) !important;\r\n  border-color: rgb(0, 123, 255) !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.checkDetailList,\r\n.receiptInfoCheck {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 15px;\r\n  padding: 10px;\r\n  background-color: #f9f9f9;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n}\r\n\r\n.receiptInfoCheck div {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n.receiptInfoCheck i.receiptIcon {\r\n  margin-right: 5px;\r\n  font-size: 16px;\r\n  color: #555;\r\n}\r\n\r\n.productsList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n  padding: 10px;\r\n  background-color: #f9f9f9;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  margin: 10px 0;\r\n  list-style: none;\r\n  overflow-x: auto;\r\n}\r\n\r\n.productsList li,\r\n.productsList i.receiptIcon {\r\n  font-size: 14px;\r\n  color: #333;\r\n  gap: 10px;\r\n}\r\n\r\n.productsList li {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n.productName {\r\n  white-space: nowrap;\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.productactual_quantity,\r\n.productPrice {\r\n  white-space: nowrap;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .productsList {\r\n    padding: 8px;\r\n    gap: 8px;\r\n  }\r\n  .productsList li {\r\n    font-size: 12px;\r\n    gap: 8px;\r\n  }\r\n  .productsList i.receiptIcon {\r\n    font-size: 14px;\r\n    margin-right: 4px;\r\n  }\r\n}\r\n\r\n.buttonGroup {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  margin-top: 15px;\r\n}\r\n\r\n.issueCheckButton,\r\n.closeReceiptButton {\r\n  padding: 12px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  width: 100%;\r\n  font-size: 0.95rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.issueCheckButton {\r\n  background-color: rgb(0, 123, 255);\r\n  color: #fff;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.closeReceiptButton {\r\n  background-color: #ffd700;\r\n  color: #fff;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkPageContainer": `CheckComponent_checkPageContainer__0sL1A`,
	"errorText": `CheckComponent_errorText__cEgKI`,
	"checkDetails": `CheckComponent_checkDetails__GMWjv`,
	"detailsList": `CheckComponent_detailsList__kg-ke`,
	"checkActions1": `CheckComponent_checkActions1__Xx9L-`,
	"checkForm1": `CheckComponent_checkForm1__6vtyr`,
	"checkModalInputGroup": `CheckComponent_checkModalInputGroup__QNyd+`,
	"contactInputWrapper": `CheckComponent_contactInputWrapper__bI-Oc`,
	"contactOptions": `CheckComponent_contactOptions__BzX9J`,
	"paymentOptions": `CheckComponent_paymentOptions__FnHwF`,
	"contactOption": `CheckComponent_contactOption__jI6Ln`,
	"paymentOption": `CheckComponent_paymentOption__NsHjX`,
	"selected": `CheckComponent_selected__WK2UD`,
	"checkDetailList": `CheckComponent_checkDetailList__ENVNZ`,
	"receiptInfoCheck": `CheckComponent_receiptInfoCheck__3Urcd`,
	"receiptIcon": `CheckComponent_receiptIcon__pbVHO`,
	"productsList": `CheckComponent_productsList__7PqaH`,
	"productName": `CheckComponent_productName__+LYZ-`,
	"productactual_quantity": `CheckComponent_productactual_quantity__LfR7b`,
	"productPrice": `CheckComponent_productPrice__Pz0qI`,
	"buttonGroup": `CheckComponent_buttonGroup__2e6M1`,
	"issueCheckButton": `CheckComponent_issueCheckButton__0ePRa`,
	"closeReceiptButton": `CheckComponent_closeReceiptButton__QpMct`
};
export default ___CSS_LOADER_EXPORT___;
